import { MutationTree } from 'vuex'
import { EpisodeState } from '../types'
import setEpisode from './setEpisode'
const mutations: MutationTree<EpisodeState> = {
  setEpisode,
}

export default mutations
